import React from 'react';
import { useTranslation } from 'react-i18next';
import useIconFromRowName from '../../../hooks/useIconFromRowName';

import { Row, RowLeft, RowRight, IconDiv, Feature, CPOCheck } from '../VehicleHistory.styles';
import { Icon } from '@oneaudi/unified-web-components';

interface RowProps {
  row: string;
}

const RowItem: React.FC<RowProps> = ({ row }) => {
  const { t } = useTranslation();
  const icon = useIconFromRowName(row);
  return (
    <Row>
      <RowLeft>
        <IconDiv>
          <Icon name={icon} size="l" />
          {/* <IconImg src={icon} alt={`${row} icon`} /> */}
        </IconDiv>
        <Feature data-testid={`vehicle-detail-${row}`}>{t(`vehicleHistory.${row}`)}</Feature>
      </RowLeft>
      <RowRight>
        <Feature data-testid={`passed-status-${row}`}>{t('vehicleHistory.passed')}</Feature>
        <CPOCheck />
      </RowRight>
    </Row>
  );
};

export default RowItem;
